module.exports = __webpack_public_path__ + "static/img/AI-2.132a13a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AI-2.jpg
// module id = 5alI
// module chunks = 46